import { gql } from "@/gql/__generated__";
import { useQuery } from "@apollo/client";

const SUBSCRIPTION_DEPLOYMENT = gql(`
    query SUBSCRIPTION_DEPLOYMENT($subscriptionId: ID!) {
      subscription(subscriptionId: $subscriptionId){
        app {
          __typename
          id
          defaultDeployment { ... DeploymentFragment }
        }
      }
    }
  `);

export const useSubscriptionDeployment = ({
  subscriptionId
}: {
  subscriptionId: string;
}) => {
  const { data, ...rest } = useQuery(SUBSCRIPTION_DEPLOYMENT, {
    variables: { subscriptionId },
    skip: !subscriptionId
  });

  return { data: data?.subscription.app?.defaultDeployment, ...rest };
};
